import { LineChartDS } from "@qivia/ui/src/designSystem/components/Charts/LineChart";
import { TotalType } from "@qivia/ui/src/designSystem/components/Charts/CardChart";
import {
  dateFormatterDayShortMonthYear,
  dateFormatterMonthYear,
} from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { extractLineChartData } from "./lib";
import { EmptyChart } from "./emptyChart";
import { GetTransactionsAmountsPerPeriodType } from "../../transactions/transactionsAPI";
import "../../../../i18n/i18n";

export const CarbonEmissionLineChart = (props: {
  totalType: TotalType;
  data: GetTransactionsAmountsPerPeriodType;
}) => {
  const { t } = useTranslation();

  const carbonEmissionData = extractLineChartData({
    transactions: props.data,
    totalType: props.totalType,
    dataPath: "totalCarbonEmission",
    formatter:
      props.totalType === "month"
        ? dateFormatterDayShortMonthYear
        : dateFormatterMonthYear,
  });

  return (
    <>
      {!carbonEmissionData.length ? (
        <EmptyChart />
      ) : (
        <LineChartDS
          transactions={carbonEmissionData}
          legend={t("dashboard.charts.title.carbonEmission.legend")}
          unit={t("dashboard.charts.title.carbonEmission.unit")}
        />
      )}
    </>
  );
};
